import { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import ProfileCard from "./ProfileCard";
import FloatingLabelInput from "../Generic/FloatingLabelInput";

const ProfileEducationSection = ({
  form,
  setForm,
  updateProfileSection,
  validateSection,
  readOnly,
}) => {
  const [editing, setEditing] = useState(false);

  const education = form.education || {
    school: "",
    degree: "",
    field: "",
    startYear: "",
    endYear: "",
  };

  const isEmpty =
    !education.school &&
    !education.degree &&
    !education.field &&
    !education.startYear &&
    !education.endYear;

  const [localEdu, setLocalEdu] = useState(education);

  useEffect(() => {
    setLocalEdu(education);
  }, [form.education]);

  const saveEducation = async () => {
    if (!validateSection("education", localEdu)) return;
    const payload = {
      education: {
        school: localEdu.school || "",
        degree: localEdu.degree || "",
        field: localEdu.field || "",
        startYear: localEdu.startYear || "",
        endYear: localEdu.endYear || "",
      },
    };

    await updateProfileSection(payload);
    setForm((prev) => ({
      ...prev,
      education: payload.education,
    }));

    setEditing(false);
  };

  const cancelEditing = () => {
    setLocalEdu(education);
    setEditing(false);
  };

  return (
    <ProfileCard
      title="Education"
      isEditing={editing}
      onEdit={() => setEditing(true)}
      onSave={saveEducation}
      onCancel={cancelEditing}
      readOnly={readOnly}
    >
      {/* empty state shows empty text */}
      {!editing && isEmpty && (
        <div className="experience-empty-state text-center">
          <p>This section is empty</p>
          <span>Add your education details</span>

          <Button
            variant="primary"
            size="sm"
            className="cta-button mt-3"
            onClick={() => setEditing(true)}
          >
            Create
          </Button>
        </div>
      )}

      {/* View mode - has education */}
      {!editing && !isEmpty && (
        <>
          <p>
            <strong>Institution:</strong> {education.school}
          </p>
          <p>
            <strong>Degree:</strong> {education.degree}
          </p>
          <p>
            <strong>Field of Study:</strong> {education.field}
          </p>
          <p>
            <strong>Years:</strong> {education.startYear} –{" "}
            {education.endYear || "Present"}
          </p>
        </>
      )}

      {/* edit mode — show form fields */}
      {editing && (
        <>
          <div className="mb-2">
            <FloatingLabelInput
              label="Institution / School"
              type="text"
              value={localEdu.school}
              onChange={(e) =>
                setLocalEdu((p) => ({ ...p, school: e.target.value }))
              }
            />
          </div>

          <div className="mb-2">
            <FloatingLabelInput
              label="Degree (e.g., B.Tech, MBA)"
              type="text"
              value={localEdu.degree}
              onChange={(e) =>
                setLocalEdu((p) => ({ ...p, degree: e.target.value }))
              }
            />
          </div>

          <div className="mb-2">
            <FloatingLabelInput
              label="Field of Study"
              type="text"
              value={localEdu.field}
              onChange={(e) =>
                setLocalEdu((p) => ({ ...p, field: e.target.value }))
              }
            />
          </div>

          <Row>
            <Col>
              <div className="mb-2">
                <FloatingLabelInput
                  label="Start Year"
                  type="number"
                  value={localEdu.startYear}
                  onChange={(e) =>
                    setLocalEdu((p) => ({
                      ...p,
                      startYear: e.target.value,
                    }))
                  }
                />
              </div>
            </Col>
            <Col>
              <div className="mb-2">
                <FloatingLabelInput
                  label="End Year"
                  type="number"
                  value={localEdu.endYear}
                  onChange={(e) =>
                    setLocalEdu((p) => ({
                      ...p,
                      endYear: e.target.value,
                    }))
                  }
                />
              </div>
            </Col>
          </Row>
        </>
      )}
    </ProfileCard>
  );
};

export default ProfileEducationSection;
